import clsx from "clsx"
import { useLayoutEffect, useRef, useState } from "react"

import useUser from "@hooks/useUser"

import filterUserLinks from "@utils/filterUserLinks"
import generateRandomKey from "@utils/generateRandomKey"

import SideBarItem from "@organisms/SideBar/components/SideBarItem/SideBarItem"

import styles from "./SideBarItemGroup.module.scss"
import { SideBarItemGroupProps } from "./SideBarItemGroup.types"

export default function SideBarItemGroup(props: SideBarItemGroupProps) {
    const { header, items, className } = props
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const itemsRef = useRef<HTMLDivElement>(null)
    const [activeItem, setActiveItem] = useState<string | null>(null)

    const { user } = useUser()

    const toggleOpen = () => setIsOpen(!isOpen)

    const open = (itemLabel: string) => {
        if (activeItem !== itemLabel) {
            setActiveItem(itemLabel)
            setIsOpen(true)
        }
    }

    const [itemsStyle, setItemsStyle] = useState({})

    useLayoutEffect(() => {
        if (isOpen) {
            setItemsStyle({ maxHeight: itemsRef.current?.scrollHeight ?? 0 })
        } else {
            setItemsStyle({ maxHeight: 0 })
        }
    }, [isOpen])

    return (
        <div
            className={clsx(styles.base, className, {
                [styles.open]: isOpen,
            })}
        >
            <div className={styles.header}>
                <SideBarItem
                    label={header.label}
                    variant="groupHead"
                    onClick={toggleOpen}
                    isExpanded={isOpen}
                    icon={header.icon}
                    iconActive={header.iconActive}
                />
            </div>
            <div className={clsx(styles.items)} ref={itemsRef} style={itemsStyle}>
                {filterUserLinks(items, user).map((item) => (
                    <SideBarItem
                        key={generateRandomKey()}
                        label={item.label}
                        path={item.path}
                        variant="groupItem"
                        isExpanded={isOpen}
                        onActive={open}
                        icon={item.icon}
                        iconActive={item.iconActive}
                    />
                ))}
            </div>
        </div>
    )
}
